import { render, staticRenderFns } from "./puntoRetiro.vue?vue&type=template&id=2262198e&scoped=true"
import script from "./puntoRetiro.vue?vue&type=script&lang=js"
export * from "./puntoRetiro.vue?vue&type=script&lang=js"
import style0 from "./puntoRetiro.vue?vue&type=style&index=0&id=2262198e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2262198e",
  null
  
)

export default component.exports